<template>
  <div class="credit-platform">
    <!-- 顶部导航区域 -->
    <div id="header">
      <TopNav></TopNav>
      <Banner v-if="$route.path=='/home'"></Banner>
    </div>

    <!-- 统计栏区域 -->
    <div v-show="$route.path == '/home'" class="stats-bar">
      <div class="stats-container">
        <div class="stat-item" v-for="(item, index) in statsList" :key="index">
          <div class="stat-icon">
            <img :src="require('@/assets/img/2026/' + item.icon)" />
          </div>
          <div class="stat-info">
            <div class="stat-number">{{ infoList[item.number] }}<span>{{ item.unit }}</span></div>
            <div class="stat-label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </div>
<!-- :class="{ 'top-100': hideBanner }" -->
    <!-- 内容区域 -->
    <div class="content">
      <router-view></router-view>
    </div>

    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
/* 组件导入 */
import TopNav from "@/components/TopNav";
import Banner from "@/components/Banner";
import Footer from "@/components/Footer";
import {
  getStatistics,
} from "@/api";
export default {
  name: "index",
  data() {
    return {
      statsList: [
        { icon: "bar-1.png", number: "rzqy", label: "入驻企业", unit: "家" },
        { icon: "bar-2.png", number: "jrjg", label: "入驻金融机构", unit: "家" },
        { icon: "bar-3.png", number: "jrcp", label: "上架金融产品", unit: "个" },
        { icon: "bar-4.png", number: "fbxqje", label: "发布需求金额", unit: "万元" },    
        { icon: "bar-5.png", number: "ljfdbs", label: "累计成交笔数", unit: "笔" },
        { icon: "bar-6.png", number: "ljfdje", label: "累计放款金额", unit: "万元" },
      ],
      infoList: {},
    };
  },
  computed: {
    /** 判断是否隐藏 Banner */
    hideBanner() {
      return (
        this.$route.name == "article" ||
        this.$route.name == "authority" ||
        this.$route.name == "projectInfo" ||
        this.$route.name == "myEnterprise" ||
        this.$route.name == "mySignUp"||
        this.$route.name == "aboutUs"
      );
    },
  },
  mounted() {
    this.getStatisticsData();
  },
  components: {
    TopNav,
    Banner,
    Footer,
  },
  methods: {
    /** 获取统计数据 */
    getStatisticsData() {
      getStatistics().then((res) => {
        this.infoList = Object.assign({}, res.data);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.credit-platform {
  min-width: 1200px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#header {
  position: relative;
  /* 顶部导航栏 fixed 定位，预留 70px 占位避免内容被遮挡 */
  padding-top: 70px;
}

/* 统计栏样式 */
.stats-bar {
  width: 100%;
  height: 100px;
  position: relative;
  overflow: hidden;
      background: linear-gradient(to right, #4C54FD, #5953FD,#1177FD);
}

.stats-bar::before {
  /* content: "";
  position: absolute;
  top: -106px;
  left: 1px;
  width: 1920px;
  height: 367px;
  background-color: #e8eef5; */
  /* 实际使用时替换为真实背景图 */
  /* background-image: url('~@/assets/images/stats-bg.jpg'); */
  /* background-size: cover; */
}

.stats-container {
  position: relative;
  z-index: 1;
  width: 1500px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
    justify-content: space-between;
  /* padding: 0 209px; */
}

.stat-item {
  // flex: 1;
  display: flex;
  align-items: center;
  // gap: 15px;
  // padding: 6px 12px;
}

.stat-icon {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
  img{
    width: 100%;
    height: 100%;
  }
  /* 实际使用时替换为真实图标 */
  /* background-image: url('~@/assets/images/stat-icon-1.png'); */
  /* background-size: cover; */
}

.stat-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.stat-number {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 32px;
  line-height: 1;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  span {
    font-size: 16px;
  }
}

.stat-number span {
  font-size: 14px;
  margin-left: 5px;
  color: #9496FD;
}

.stat-label {
  font-family: "PingFang SC", sans-serif;
  font-size: 18px;
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
}

/* 内容区域 */
.content {
  min-height: calc(100vh - 160px);
// padding-top: 70px;
  position: relative;
   background: 
      linear-gradient(to bottom, #EBF3FE 30%, #BADBFE 60%),
      linear-gradient(to right, #ACD6FC, #BADBFE, #BFD9FE, #CDCEFC);
}

.content.top-100 {
  margin-top: 0;
}

/* 动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
